import office from '@/taskpane/officejs/office-wrapper'
import state from '@/taskpane/state/sidebar-state'
import sendMailItemOpenMessage from './send-item-open-message-mail'
import sendEventItemOpenMessage from './send-item-open-message-event'

export default async function sendItemOpenMessage() {
  if (state.sidebarIsConnected && state.sidebarIsAuthenticated) {
    if (office.mode.isMessage() && !office.mode.isInvitation()) {
      await sendMailItemOpenMessage()
    } else if (office.mode.isAppointment() || office.mode.isInvitation()) {
      await sendEventItemOpenMessage()
    }
  }
}
